import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { Tab } from 'src/app/components/_purpose-built-components/checkout-tab-bar/checkout-tab-bar.component';

@Component({
    selector:        'gc-tab-bar',
    templateUrl:     './gc-tab-bar.component.haml',
    styleUrls:       ['./gc-tab-bar.component.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone:      false
})
export class GcTabBarComponent {
  menuTabs = input<Tab[]>(undefined);
  tabSelect = model<string>(undefined);

}
